// DestinationDropdown.js
import { defineComponent, computed } from "/Scripts/vue.esm-browser.js";
const html = String.raw;

export default defineComponent({
  name: "DestinationDropdown",
  props: {
    deptInfos: { type: Array, required: true },
  },
  inject: ["dept"],
  emits: [],
  setup(props, { emit }) {
    const currentDept = computed(() =>
      props.deptInfos.find((dept) => dept.active),
    );
    const othersDept = computed(() =>
      props.deptInfos.filter((dept) => !dept.active),
    );
    return {
      currentDept,
      othersDept,
    };
  },
  template: html`
    <div class="mobile-dropdown">
      <button id="dropBtn" class="dropbtn">
        <span>{{currentDept.text}}</span>出發
      </button>
      <ul id="dropContent" class="dropdown-content">
        <li v-for="dept in othersDept" :key="dept.key">
          <a :href="'/Promotions/ClearanceSale/清艙快閃王?dept='+dept.key"
            >{{dept.text}}</a
          >
        </li>
      </ul>
    </div>
  `,
  methods: {},
});
